import { GetServerSideProps } from 'next';
import { lazy, Suspense } from 'react';
import { lazily } from 'react-lazily';

import { getByUrl } from 'services/freeform';
import { HeadObject } from 'services/generic';
import { getCategories, getTrandings } from 'services/helpcentre';

import type { FreeFormBody } from 'core/mancity/template/freeform';

import {
	addFreeformControlData,
	addTrandingRelatedControl,
} from '@help-centre/helpers';

import styles from './index.module.scss';

const Seo = lazy(() => import('core/mancity/components/general/seo'));
const { FreeformPage } = lazily(() => import('core/mancity/template/freeform'));

type IndexPropsType = {
	body: FreeFormBody;
	metaData: HeadObject;
};

export function Index({ body, metaData }: IndexPropsType) {
	return (
		<>
			<Suspense>
				<Seo head={metaData} />
			</Suspense>
			<div className={styles.container}>
				<div className="row">
					<div className="col-12">
						<Suspense>
							<FreeformPage body={body} isLandingPage={true} />
						</Suspense>
					</div>
				</div>
			</div>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const categories = await getCategories().then((response) => response);
	const trandings = await getTrandings().then((response) => response);
	let metaData = null;

	const body = await getByUrl('/help', 'en', 'gb')
		.then((response) => {
			metaData = { ...response.head };
			return addFreeformControlData(
				response,
				'ZenDeskCategories',
				categories
			);
		})
		.catch(() => null);
	if (!body || !metaData) {
		return { notFound: true };
	}

	return {
		props: {
			body: addTrandingRelatedControl(
				body,
				'ZenDeskCategories',
				trandings?.articles || []
			),
			metaData,
		},
	};
};

export default Index;
